import {
	userFileConstants
}from "./constants"

const initialState =
{
	isSending : false,
	paged     : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case userFileConstants.GetPaged.REQUEST:
		case userFileConstants.GetFile.REQUEST:
			return {
				...state,
				isSending: true
			}
		case userFileConstants.GetPaged.FAILURE:
		case userFileConstants.GetFile.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case userFileConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case userFileConstants.GetFile.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case userFileConstants.CLEAR:
			return {
				...state,
				isSending : false,
				paged     : {}
			}
		default:
			return state
	}
}